import "../../css/header.css";

export function Header() {

  return (
    <header className="header _scroll-snap__block">
      <div className="header__container">
        <div className="header-bg"></div>
        <div className="header__content">
          <div className="header__content-bg"></div>
        </div>
      </div>
    </header>
  );
}
